import React from "react";

const Footer = () => (
  // TODO: use theme instead of inline styling
  <div className="jumbotron footer" style={{ margin: 0, borderTop: "1px solid #dedede" }}>
    <div className="container">
      <div className="row">
        <div className="col-md-12">
          <div className="legal">
            <a href="https://www.westnat.com/legal-and-compliance/company-registration-details/" target="_blank">Legal Details</a>&nbsp;|&nbsp;
            <a href="https://www.westnat.com/legal-and-compliance/protection-of-personal-information/" target="_blank">Privacy Policy</a>
          </div>
          <div className="copyright">
            Western National © 2019
          </div>
          <div className="copyright">
            v1.3
          </div>        
        </div>  
      </div>
    </div>
  </div>
);

export default Footer;
